import BodyText, {BodyTextProps} from './BodyText';

export default BodyText;
export type {BodyTextProps};
